import React, { useState, useEffect } from "react";
import { addCommas, fromUnix } from '@arema/components/Util';
import { Header, Icon, Table } from 'react-frontier2';
import { useParams, Link } from "react-router-dom";
import { PaymentMethods } from "@arema/components/Classes";
import API from "../../API";

interface Props {
	promoter_id?: number,
	onEditPromoter?: Function,
}

interface OrdersConciliacion {
	payment_id: number,
	order_id: number,
	payment_method: PaymentMethods,
	pdv_id: number,
	pdv_name: string,
	method_name: string,
	method_name_internal: string,
	amount: number,
	total_deposit: number,
	commission: number,
	date_paid: number,
}

var renderpdv = (val: any, row: OrdersConciliacion) => {
	return (row && row.pdv_id) ? `[${row.pdv_id}] ${row.pdv_name}` : <Icon name="minus" color="gray" />;
}

var renderCompleted = (val: number, row: OrdersConciliacion) => {
	return !!val ? <i className="check icon green"></i> : <i className="times icon gray"></i>;
}

const ConciliacionEventMethod = (props: Props) => {
	var [ordersConcilia, setOrdersConcilia] = useState<OrdersConciliacion[]>(null);
	var [eventInfo, setEventInfo] = useState<{ event_id: number, event_name: string, method_name_internal: string }>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var { event_id, method_id } = useParams();
	const HEADERS: {
		name: string,
		key?: keyof OrdersConciliacion,
		collapsing?: boolean,
		centered?: boolean,
		render?: (val: any, obj: any) => any
	}[] = [
		{ name: 'Folio', key: 'order_id', collapsing: true },
		{ name: 'PDV', key: 'pdv_name', centered: true, render: renderpdv },
		{ name: 'Fecha', key: 'date_paid', render: v=>fromUnix(v).toFormat('dd/MM/yy HH:mm') },
		{ name: 'Metodo', key: 'method_name_internal' },
		{ name: 'Total', key: 'amount', collapsing: true, centered: true, render: addCommas },
		{ name: 'Conciliado', key: 'total_deposit', collapsing: true, centered: true, render: addCommas },
		// { name: 'Completado', key: 'completed', centered: true, render: renderCompleted },
	];

	useEffect(() => {
		loadOrders()
	}, []);

	var loadOrders = async () => {
		API.getEventOrdersConcilia(parseInt(event_id), parseInt(method_id), null, 0, 9999).then((res) => {
			if (res.error) setLoadError(res.message);
			if (res.data) {
				setOrdersConcilia(res.data.orders);
				setEventInfo(res.data.event_info);
			}
		}).catch(e => {
			setLoadError('Error inesperado LCL1');
		});
	}

	if (loadError) return <Header text="Error" subtext={loadError} />
	if (!ordersConcilia) return <Header loading text="Cargando ordenes" />

	const collapsingIndexes = HEADERS.map((row, index) => row.collapsing ? index : null).filter(r => r !== null)
	const centeredIndexes = HEADERS.map((row, index) => row.centered ? index : null).filter(r => r !== null)
	const renderRow = (ordersConcilia && ordersConcilia.length !== 0) ? ordersConcilia.map((r, index)=>(
		<Table.Row compact
			as={Link} 
			to={`/orders/@${r.order_id}`}
			key={`RW-${r.order_id}-${index}`}
			collapsingIndexes={collapsingIndexes}
			centeredIndexes={centeredIndexes}
			data={HEADERS.map(h=>(h.render ? h.render(r[h.key], r) : r[h.key]))}
		/>
	)) : (
		<Table.Cell row empty colSpan={100} value={'No se encontraron ordenes en esta conciliación'} />
	);

	return (
		<div style={{ maxWidth: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
			<Header
				text={`[${eventInfo.event_id}] ${eventInfo.event_name}`} 
				subtext={`Ordenes: ${eventInfo.method_name_internal}`}
			/>
			<Table striped selectable style={{ maxWidth: 900, margin: 'auto' }}>
				<Table.Head 
					title={'Conciliacion Faltante'}
					collapsingIndexes={collapsingIndexes} 
					centeredIndexes={centeredIndexes} 
					data={[HEADERS.map(r=>r.name)]} 
				/>
				<Table.Body>
					{renderRow}
				</Table.Body>
			</Table>
		</div>
	)
}

export default ConciliacionEventMethod;